import { MODAL_OPEN, MODAL_CLOSE } from './types';

export const modalOpen = (id, params = {}) => ({
  type: MODAL_OPEN,
  payload: id,
  params,
});

export const modalClose = (id) => ({
  type: MODAL_CLOSE,
  payload: id,
});
